import contenttype from '../templates/contenttype';
export default class Rssfeed {
  constructor(el) {
    this.el = el;
    this.feed = encodeURIComponent(this.el.dataset.feedurl);
    this.items = parseInt(this.el.dataset.items) || 5;
    this.reversed =
      this.el.dataset.reversed && this.el.dataset.reversed == 'true';
    this.tile = this.el.parentNode.classList.contains('tileText');
    this.dataurl = `/feeds/rss/xml2json.html?url=${this.feed}`;
  }

  getdata() {
    return fetch(this.dataurl)
      .then((response) => response.json())
      .then((data) => {
        this.data = data;
      });
  }

  appenddata(config) {
    !config ? (config = {}) : false;
    const feed = Array.isArray(this.data.rss.channel.item)
      ? this.data.rss.channel.item
      : [this.data.rss.channel.item];
    if (this.reversed) {
      feed
        .slice()
        .reverse()
        .forEach((item, i) => {
          if (this.tile) {
            i <= this.items
              ? this.el.insertAdjacentHTML(
                  'beforeend',
                  `<li><a href="${item.link}">${item.title}</a></li>`
                )
              : false;
          } else {
            i <= this.items
              ? this.el.insertAdjacentHTML(
                  'beforeend',
                  contenttype.card({
                    content: item.description,
                    heading: item.title,
                    link: item.link,
                  })
                )
              : false;
          }
        });
    } else {
      feed.forEach((item, i) => {
        if (this.tile) {
          i <= this.items
            ? this.el.insertAdjacentHTML(
                'beforeend',
                `<li><a href="${item.link}">${config.description ? `<strong>${item.title}</strong><br />${item.description}` : item.title}</a></li>`
              )
            : false;
        } else {
          i <= this.items
            ? this.el.insertAdjacentHTML(
                'beforeend',
                contenttype.card({
                  content: item.description,
                  heading: item.title,
                  link: item.link,
                })
              )
            : false;
        }
      });
    }

    this.el.style.display = 'block'; /**todo remove this necessity in t4 */
  }
}
